import { CloseRounded } from "@mui/icons-material";
import { DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Typography, TextField, FormHelperText } from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import { Button, FormTextField } from "../../../components";
import Notifier, { INotifierProps } from "../../../components/Notifier/Notifier";
import Yup, { YupUtils } from "../../../configs/yup";
import { IAddProps } from "../../../models/Global/types";
import useUnits from "../../../services/useUnit";
import useClient from "../../../services/useClient";

function UnityForm({ setAdd, formData }: IAddProps) {
    const { unityMutation, unityUpdateMutation } = useUnits();
    const { getClients } = useClient();
    const [notifier, setNotifier] = React.useState<INotifierProps>();
    const initialValues = formData ? formData : {
        unity: '',
        bed: '',
        company_id: '',
        unity_integration: '',
        bed_integration: '',
        active: true
    }

    const validations = Yup.object().shape({
        unity: Yup.string().required(YupUtils.mesages.REQUIRED_MESAGE),
        bed: Yup.string().required(YupUtils.mesages.REQUIRED_MESAGE),
        company_id: Yup.string().required(YupUtils.mesages.REQUIRED_MESAGE),
        unity_integration: Yup.number().required(YupUtils.mesages.REQUIRED_MESAGE),
        bed_integration: Yup.number().required(YupUtils.mesages.REQUIRED_MESAGE),
    });
    function handleSubmit(values) {

        if (formData) {
            unityUpdateMutation.mutate(values, {
                onSuccess: (response) => {
                    setNotifier({ open: true, msg: "Unidade Atualizada Com Sucesso!", severity: 'success' });
                    setTimeout(() => setAdd(false), 1000);
                },
                onError: (error) => {
                    setNotifier({ open: true, msg: "Erro ao atualizar Unidade.", severity: 'error' });
                },
                onSettled: () => { },
            });
            return
        }

        unityMutation.mutate(values, {
            onSuccess: (response) => {
                setNotifier({ open: true, msg: "Unidade Cadastrada Com Sucesso!", severity: 'success' });
                setTimeout(() => setAdd(false)
                    , 1000);
            },
            onError: (error) => {
                setNotifier({ open: true, msg: "Erro ao cadastrar Unidade.", severity: 'error' });
            },
            onSettled: () => { },
        });
    }


    return (
        <>
            <Notifier
                msg={unityMutation.error?.errorMessage || notifier?.msg}
                closeState={setNotifier}
                severity={notifier?.severity}
                open={notifier?.open}
                closeTime={notifier?.closeTime}
            />
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography fontSize={16} fontWeight="bold" color="secondary">
                    Adicionar Unidade
                </Typography>
                <IconButton onClick={() => setAdd(false)}>
                    <CloseRounded />
                </IconButton>
            </DialogTitle>
            <DialogContent
                dividers
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                }}
            >
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    validationSchema={validations}
                >
                    {({ setFieldValue, values, errors }) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid xs={12} item>
                                    <FormTextField name="unity" label="Nome" value={values?.unity} ></FormTextField>
                                </Grid>
                                <Grid xs={12} item>
                                    <FormTextField name="bed" label="Leito" value={values?.bed} ></FormTextField>
                                </Grid>
                                <Grid xs={12} item>
                                    <FormControl fullWidth>
                                        <TextField error={(!!errors.company_id)} name="company_id" label="Cliente" value={values.company_id} onChange={(event) => setFieldValue('company_id', event.target.value.toLocaleString(), true)} select>
                                            {getClients.data?.data.map((option) =>
                                                (<MenuItem value={option._id}>{option.name}</MenuItem>)
                                            )}
                                        </TextField>
                                        <FormHelperText sx={{ color: (theme) => theme.palette.warning.main }}>{errors.company_id}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid xs={4} item>
                                    <FormTextField type="number" name="unity_integration" label="Unidade de Integração" value={values?.unity_integration} ></FormTextField>
                                </Grid>
                                <Grid xs={4} item>
                                    <FormTextField type="number" name="bed_integration" label="Leito de Integração" value={values?.bed_integration} ></FormTextField>
                                </Grid>
                                <Grid xs={4} item>
                                    <FormControl fullWidth>
                                        <InputLabel id="active">Status</InputLabel>
                                        <Select name="active" labelId="active" defaultValue={values.active.toString()} onChange={(event) => setFieldValue('active', JSON.parse(event.target.value))} label="Status">
                                            <MenuItem value={'true'}>Ativo</MenuItem>
                                            <MenuItem value={'false'}>Inativo</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid xs={12} item>
                                    <Button type={"submit"} loading={unityMutation.isLoading}>
                                        Enviar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </>
    );
}

export default UnityForm;